import { render, staticRenderFns } from "./RecordQuery.vue?vue&type=template&id=72a1bb7a&scoped=true&"
import script from "./RecordQuery.vue?vue&type=script&lang=js&"
export * from "./RecordQuery.vue?vue&type=script&lang=js&"
import style0 from "./RecordQuery.vue?vue&type=style&index=0&id=72a1bb7a&prod&scoped=true&lang=css&"
import style1 from "./RecordQuery.vue?vue&type=style&index=1&id=72a1bb7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1bb7a",
  null
  
)

export default component.exports